import React from 'react';
import { CardContainer } from '@welbe/web-design-system';
import { Container, Text, Title } from './Card.styles';

type CardProps = {
	id?: string;
	onClick: () => void;
	title: string;
	text: string;
	img: string;
	disabled?: boolean;
};

export const Card = ({
	onClick,
	title,
	text,
	img,
	id,
	disabled,
}: CardProps): JSX.Element => {
	return (
		<CardContainer
			id={id ? `card-${id}` : 'card'}
			type="horizontal"
			height="230px"
		>
			<Container onClick={onClick} disabled={disabled}>
				<img src={img} />
				<Title>{title}</Title>
				<Text disabled={disabled}>{text}</Text>
			</Container>
		</CardContainer>
	);
};
